/* Erkennung der Links aus Supabase-Mails (Einladung, Registrierung, Zurücksetzen) — reine Funktion, kein DOM.
 *
 * Die Art des Links steckt in der Adresse:
 *   #access_token=…&type=invite|signup|recovery   Hash-Fluss (implicit) — Sitzung steckt im Link
 *   ?token_hash=…&type=invite|signup|recovery     eigene Mailvorlage — Token muss per verifyOtp eingelöst werden
 *   ?code=…                                       PKCE-Fluss — die App nutzt den Hash-Fluss, kann das nicht einlösen
 *   #error=access_denied&error_code=otp_expired   Supabase meldet: Link abgelaufen oder schon benutzt
 *
 * Wer hier "error" oder "code" bekommt, soll eine verständliche Meldung sehen statt stumm im Login zu landen.
 * Genutzt von composables/useAuth.js.
 */

const LINK_TYPES = ['invite', 'signup', 'recovery'];

function paramsOf(part) {
  return new URLSearchParams(String(part || '').replace(/^[#?]/, ''));
}

/**
 * @param {string} hash   window.location.hash beim Start (INITIAL_HASH)
 * @param {string} search window.location.search beim Start
 * @returns {{kind: 'none'|'session'|'tokenHash'|'code'|'error', type?: string, tokenHash?: string, problem?: 'expired'|'invalid'}}
 *   problem: 'expired' = Link abgelaufen oder schon benutzt, 'invalid' = Link in dieser App nicht verwendbar
 */
export function parseAuthLink(hash, search) {
  const h = paramsOf(hash);
  const q = paramsOf(search);

  if (h.has('error') || h.has('error_code') || q.has('error') || q.has('error_code')) {
    const code = h.get('error_code') || q.get('error_code') || '';
    const text = `${h.get('error_description') || ''} ${q.get('error_description') || ''}`;
    const expired = code === 'otp_expired' || /expired|already/i.test(text);
    return { kind: 'error', problem: expired ? 'expired' : 'invalid' };
  }

  if (h.has('access_token')) {
    return { kind: 'session', type: LINK_TYPES.includes(h.get('type')) ? h.get('type') : '' };
  }

  const tokenHash = q.get('token_hash');
  if (tokenHash) {
    const type = q.get('type');
    if (LINK_TYPES.includes(type)) return { kind: 'tokenHash', tokenHash, type };
    return { kind: 'error', problem: 'invalid' };
  }

  if (q.has('code')) return { kind: 'code', problem: 'invalid' };

  return { kind: 'none' };
}
